import { createObjectPagePathname, getAsServerMediaUrl, getMediaUrl } from "@/services/pathname"
import Link from "next/link"
import moment from "moment"
import { getName } from "@/services/aroeven"
import Image from "next/image"

type CardProps = {
    aroeven: Aroeven,
    post: Post
}
export default function Card({
    post,
    aroeven
}: CardProps) {
    const isOtherAroeven = post.publishedBy.slug !== aroeven.slug
    const isAvailableLocally = post.sharingStatus === 'forced' || (aroeven.federation === true && post.sharingStatus === 'approved')
    const useExternalLink = isOtherAroeven && !isAvailableLocally

    return (
        <Link href={(useExternalLink ? post.publishedBy.url : '') + createObjectPagePathname('Post', post)} {...useExternalLink && { target: "_blank"}} className="vignette -type-1 h-100">
            <div className="vignette__image">
                <div className="cardImage">
                    <div className="cardImage__content">
                        <Image
                            src={getAsServerMediaUrl(post.mainImage?.url ?? '#')}
                            width={post.mainImage.metadata.width}
                            height={post.mainImage.metadata.height}
                            className="col-12"
                            alt="image"
                            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                            quality={50}
                        />
                        {/*<img className="col-12" src={getMediaUrl(post.mainImage?.url ?? '#')} alt="image" />*/}
                    </div>
                    <div className="cardImage__leftBadge">
                        <div className="tag">
                            <h3 className="tag-title">{moment(post.publishedAt).format('DD/MM/YYYY')}</h3>
                            <div className="tag-tail" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="vignette__content pt-10">
                <div className="d-flex flex-column justify-content-between h-100">
                    <div>
                        <h4 className="vignette__title py-10">
                            {post.title}
                        </h4>
                        <p className="mb-10">{post.short}</p>
                    </div>
                    <div>
                        <div className="organisation d-flex items-start">
                            <div className="flex-center size-20 rounded-full bg-primary-3 mr-5 text-white">
                                <i className="fi fi-rr-home" />
                            </div>
                            <div className='lh-1 mb-5'>Publié par {getName(post.publishedBy)}</div>
                        </div>
                    </div>
                </div>
            </div>
        </Link>

    )
}